<template>
  <div>
    <b-card style="width:1000px;margin-left:230px;margin-top:50px" header="Search User">
 
      <b-row style="margin-left:250px">
        <div class="col-md-8">
          <div class="form-group mt-8 mt-sm-0">
            <!-- <label for="default">Search User</label> -->
            <input
              v-model="mnumber"
              class="form-control"
              type="number"
              placeholder="Enter Mobile Number"
            />
          </div>
          <v-btn  class="primary mr-4" @click="handleSubmit">Get Details</v-btn>
          <!-- <b-button  class="primary mr-4" @click="handleSubmit">Get Details</b-button> -->
        </div>
      </b-row>
    </b-card>
    <!-- <b-row style="margin-left:20px">
        <v-col md="6">
          <div>
            <h5>Customer Name : {{name}}</h5>
          </div>
          <h5>Serial No : {{serialno}}</h5>
          <div>
            <h5>Account NO : {{id}}</h5>
          </div>
          <div>
            <h5>Balance : {{id1}}</h5>
          </div>
        </v-col>
    </b-row>-->

    <b-card  v-show="show" style="width:1000px;margin-left:230px">
      <div class="col-md-12">
        <fieldset class="border p-2">
          <legend class="w-auto">
            <h4 class="header-title mt-0 mb-1">Customer Info</h4>
          </legend>
          <div class="row">
            <div class="col-md-3">
              <div class="form-group mt-3 mt-sm-0">
                <label for="default" style="color:black">Customer Name</label>
                <input
                  v-model.trim="name"
                  placeholder="Check Cutomer Name"
                  class="form-control"
                  type="text"
                  disabled
                />
              </div>
            </div>
            <div class="col-md-3">
              <div class="form-group mt-3 mt-sm-0">
                <label for="default" style="color:black">Serial No</label>
                <input
                  v-model.trim="serialno"
                  class="form-control"
                  type="number"
                  disabled
                  placeholder="Check Serial Number"
                />
              </div>
            </div>

            <div class="col-md-3">
              <div class="form-group mt-3 mt-sm-0">
                <label for="default" style="color:black">Account NO</label>
                <input
                  v-model.trim="id"
                  class="form-control"
                  type="number"
                  disabled
                  placeholder="Check Account No"
                />
              </div>
            </div>

            <div class="col-md-3">
              <div class="form-group mt-3 mt-sm-0">
                <label for="default" style="color:black">Balance</label>
                <input
                  v-model.trim="id1"
                  class="form-control"
                  type="number"
                  disabled
                  placeholder="Check Balance"
                />
              </div>
            </div>
          </div>
        </fieldset>
      </div>
      <v-form class="container p-5" ref="form" v-model="valid" lazy-validation>
        <h3>
          <b>Update Wallet Balance</b>
        </h3>
        <v-col style="margin-left:150px;">
          <v-text-field v-model="form.amount" label="Enter Amount " required style="width:500px"></v-text-field>
        </v-col>
        <v-btn :disabled="!valid" class="primary mr-4" @click="handleSubmit1">Update Amount</v-btn>
      </v-form>
    </b-card>
    <!-- <v-col class="d-flex" cols="8" sm="3" style="margin-left:100px;">
          <v-select :items="items" label="Solo field" solo></v-select>
    </v-col>-->
    <!-- <v-row>
        <v-col>
          <v-form class="container p-5" ref="form" v-model="valid" lazy-validation>
            <h3>
              <b>Update Wallet Balance</b>
            </h3>
            <v-col style="margin-left:100px;">
              <v-text-field
                v-model="form.amount"
                label="Enter Amount "
                required
                style="width:500px"
              ></v-text-field>
            </v-col>
            <v-btn :disabled="!valid" class="primary mr-4" @click="handleSubmit1">Update Amount</v-btn>
          </v-form>
        </v-col>
    </v-row>-->
  </div>
</template>
<script>
import { extractError } from "../../utils/error";
import { getuser } from "@/services/wallet";
import { walletupdate } from "@/services/walletupdate";
export default {
  data() {
    return {
      radios: "credit",
      form: {
        accountNo: "",
        amount: "",
      },
      mnumber: "",
      mobilenumberRules: [(v) => !!v || "Mobile Number is required"],
      valid: true,
      select: null,
      id: "",
      serialno: "",
      id1: "",
       show: false,
      name: "",
      loading: true,
    };
  },
  methods: {
    validate() {
      if (this.$refs.form.validate()) {
        this.snackbar = true;
      }
    },
    async handleSubmit() {
      try {
        // const { form, ...payload } = this.form;

        const result = await getuser(this.mnumber);
         this.show = true
        const data = result.response.result;
        this.name = data.userProfile.customer_NAME;
        this.serialno = data.serialNo;
        this.id = data.accountNo;
        this.id1 = data.walletBalance;
        console.log(name);
      } catch (err) {
        const message = extractError(err);
        // this.$showError(message);
      }
    },
      async refresh() {    
    setTimeout(function () {
        location.reload()
    }, 200);
    },
    async handleSubmit1() {
      try {
        const hasError = this.validate();
        if (hasError) {
          this.$toasted.error(hasError, {
            duration: 2000,
          });
          return;
        }
        const { form, ...payload } = this.form;
        const result = await walletupdate({
          accountNo: this.id,
          amount: this.form.amount,
        });
        //const { response: { userID: userId }  } = result;
        payload[form] = true;
        this.$router.push({
          
          name: "Walletupdate",
          params: {},
        });
        
        this.$toasted.success("Successfully created", {
          duration: 2000,
        });
         this.refresh()
      } catch (err) {
        const message = extractError(err);
        this.$showError(message);
      }
    },
  },
};
</script>
<style scoped>
/* .forum{
    margin-left:3 rem !important;
} */
.card-header {
    padding: 0.75rem 1.25rem;
    margin-bottom: 0;
    background-color: rgba(0, 0, 0, 0.03);
    border-bottom: 1px solid rgba(0, 0, 0, 0.125);
    background: linear-gradient( 
225deg, #59065d 0%, #8d0b93 50%, #061d48 100% );
    color: white;
}
</style>